import { CheckboxComponent } from './checkbox/checkbox.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { InputComponent } from './input/input.component';
import { SelectComponent } from './select/select.component';

export const componentsCommon = [
  CheckboxComponent,
  DatePickerComponent,
  InputComponent,
  SelectComponent,
];
